import React, {useState} from "react";
import s from "./Menu.module.css";
import MenuIcon from '@material-ui/icons/Menu';
import ShareIcon from '@material-ui/icons/Share';
import SearchIcon from '@material-ui/icons/Search';
import MobileMenu from "../MobileMenu/MobileMenu";
import FacebookIcon from "@material-ui/icons/Facebook";
import InstagramIcon from "@material-ui/icons/Instagram";
import YouTubeIcon from "@material-ui/icons/YouTube";
import EmailIcon from "@material-ui/icons/Email";

const Menu = () => {
  const [isOpen, setIsOpen] = useState();
  const [isVisible, setIsVisible] = useState(false);

  const isBurgerOpen = () => {
    setIsOpen(!isOpen)
  }

  const handleIsVisible = () => {
    setIsVisible(!isVisible)
  }

  return (
    <div className={s.menu_container}>
      <div className={s.burger_container}>
        <div className={s.burger_icon} onClick={isBurgerOpen}>
          <MenuIcon/> <span>МЕНЮ</span>
        </div>
        <div className={s.search_share}>
          <SearchIcon className={s.search_icon} onClick={handleIsVisible}/>
          <ShareIcon className={s.share_icon} onClick={handleIsVisible}/>
        </div>
      </div>
      {isVisible &&
      <div className={s.search_share_container}>
        <input className={s.search_input} placeholder={'Пошук...'}/>
        <div className={s.social}>
          <a href={'https://www.facebook.com/economicsTNEU/'}>
            <FacebookIcon className={s.fb}/>
          </a>
          <a href={'https://instagram.com/kafedra_eet?igshid=1sexx39r6cwxd'}>
            <InstagramIcon className={s.insta}/>
          </a>
          <a href={'https://www.youtube.com'}>
            <YouTubeIcon className={s.youtube}/>
          </a>
          <a href={'mailto:kaf_et@wunu.edu.ua'}>
            <EmailIcon className={s.email}/>
          </a>
        </div>
      </div>}
      <MobileMenu isOpen={isOpen} setIsOpen={setIsOpen}/>
    </div>
  )
}

export default Menu;
